<main>
    <div class="content">
        <div class="main-image">
            <img [src]="baseApiUrl + '/uploads/images/what_new/detail/nonghyup-bank/nonghyup_bank_1.jpg'" alt="">
            <p class="image-text">{{ 'nonghyup_bank.HEADER' | translate }}</p>
        </div>
        <div class="paragraph">
            <div class="title">
                <h2>{{ 'nonghyup_bank.TITLE1' | translate }}</h2>
                <h2>{{ 'nonghyup_bank.TITLE2' | translate }}</h2>
            </div>
            <div class="desc">
                <p>{{ 'nonghyup_bank.DESC' | translate }}</p>
            </div>
            <div class="gallery">
                <div class="row">
                    <div class="col">
                        <img [src]="baseApiUrl + '/uploads/images/what_new/detail/nonghyup-bank/nonghyup_bank_2.jpg'" alt="">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <img [src]="baseApiUrl + '/uploads/images/what_new/detail/nonghyup-bank/nonghyup_bank_3.jpg'" alt="">
                    </div>
                    <div class="col">
                        <img [src]="baseApiUrl + '/uploads/images/what_new/detail/nonghyup-bank/nonghyup_bank_4.jpg'" alt="">
                    </div>
                </div>
                <div class="row g-4">
                    <div class="col">
                        <img [src]="baseApiUrl + '/uploads/images/what_new/detail/nonghyup-bank/nonghyup_bank_5.jpg'" alt="">
                    </div>
                    <div class="col">
                        <img [src]="baseApiUrl + '/uploads/images/what_new/detail/nonghyup-bank/nonghyup_bank_6.jpg'" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-content">
        <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
        <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
    </div>
</main>